const newModel = () => {
    return {
        thethaoSunghiepId: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        tenPhuongXa: null,
        phuongXaId: null,
        chiTieuTapLuyen: null,
        thucHienTapLuyen: null,
        tyLeTapLuyen: null,
        tyLeSoDan: null,
        chiTieuBoiLop: null,
        thucHienBoiLop: null,
        tyLeBoiLop: null,
        chiTieuBoiNguoi: null,
        thucHienBoiNguoi: null,
        tyLeBoiNguoi: null,
        idKy: null,
        tenKy: null,
        ghiChu: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        thethaoSunghiepId: null,
        quanHuyenId: null,
        tenPhuongXa: null,
        idKy: null,
        chiTieuTapLuyen: null,
        thucHienTapLuyen: null,
        tyLeTapLuyen: null,
        tyLeSoDan: null,
        chiTieuBoiLop: null,
        thucHienBoiLop: null,
        tyLeBoiLop: null,
        chiTieuBoiNguoi: null,
        thucHienBoiNguoi: null,
        tyLeBoiNguoi: null,
        ghiChu: null,
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoSunghiepId: item.thethaoSunghiepId,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        tenPhuongXa: item.tenPhuongXa,
        phuongXaId: item.phuongXaId,
        chiTieuTapLuyen: item.chiTieuTapLuyen,
        thucHienTapLuyen: item.thucHienTapLuyen,
        tyLeTapLuyen: item.tyLeTapLuyen,
        tyLeSoDan: item.tyLeSoDan,
        chiTieuBoiLop: item.chiTieuBoiLop,
        thucHienBoiLop: item.thucHienBoiLop,
        tyLeBoiLop: item.tyLeBoiLop,
        chiTieuBoiNguoi: item.chiTieuBoiNguoi,
        thucHienBoiNguoi: item.thucHienBoiNguoi,
        tyLeBoiNguoi: item.tyLeBoiNguoi,
        idKy: item.idKy,
        tenKy: item.tenKy,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoSunghiepId: item.thethaoSunghiepId,
        quanHuyenId: item.quanHuyenId,
        phuongXaId: item.phuongXaId,
        idKy: item.idKy,
        chiTieuTapLuyen: item.chiTieuTapLuyen,
        thucHienTapLuyen: item.thucHienTapLuyen,
        tyLeTapLuyen: item.tyLeTapLuyen,
        tyLeSoDan: item.tyLeSoDan,
        chiTieuBoiLop: item.chiTieuBoiLop,
        thucHienBoiLop: item.thucHienBoiLop,
        tyLeBoiLop: item.tyLeBoiLop,
        chiTieuBoiNguoi: item.chiTieuBoiNguoi,
        thucHienBoiNguoi: item.thucHienBoiNguoi,
        tyLeBoiNguoi: item.tyLeBoiNguoi,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        idKy: null,
        quanHuyenId: null,
        phuongXaId: null,
        stt: null,
        enabled: null,
    }
}

const newSearchModel = (item) => {
    return {
        idKy: item.idKy,
        quanHuyenId: item.quanHuyenId,
        phuongXaId: item.phuongXaId,
        enabled: item.enabled,
    }
}


const errors = () => {
    return {
        thethaoSunghiepId: null,
        quanHuyenId: null,
        tenPhuongXa: null,
        idKy: null,
        chiTieuTapLuyen: null,
        thucHienTapLuyen: null,
        tyLeTapLuyen: null,
        tyLeSoDan: null,
        chiTieuBoiLop: null,
        thucHienBoiLop: null,
        tyLeBoiLop: null,
        chiTieuBoiNguoi: null,
        thucHienBoiNguoi: null,
        tyLeBoiNguoi: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const theThaoSuNghiepModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


